<template>
  <a-modal v-model="student.visible" title="配置学生" @cancel="handleCancel" width="70%" :centered="true" :destroyOnClose="true">
    <template slot="footer">
      <div v-if="student.step == 1">
        <a-button @click="student.visible = false"> 取消 </a-button>
        <a-button :loading="student.confirmLoading" type="primary" @click="next(2)"> 下一步 </a-button>
      </div>
      <div v-if="student.step == 2">
        <a-button @click="next(1)"> 上一步 </a-button>
        <a-button :loading="student.confirmLoading" type="primary" @click="studentSubmit()"> 确定 </a-button>
      </div>
    </template>
    <a-spin :spinning="student.loading" style="min-height: 300px">
      <a-form-model ref="ruleForm" :model="student.form" :rules="student.rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
        <template v-if="student.step == 1">
          <a-form-model-item label="完成状态" prop="status">
            <!-- @change="setStudent()" -->
            <a-checkbox-group v-model="student.form.status">
              <a-checkbox :value="2" name="type">已完成</a-checkbox>
              <a-checkbox :value="1" name="type">进行中</a-checkbox>
              <!-- <a-checkbox :value="0" name="type">未开始</a-checkbox> -->
            </a-checkbox-group>
          </a-form-model-item>
          <a-form-model-item label="班级选择" prop="checkedKeys">
            <a-tree
              checkable
              :key="student.treeKey"
              :replaceFields="{ children: 'childs', title: 'gradeClassName', key: 'gradeClassID' }"
              :defaultExpandAll="true"
              :tree-data="student.treeData"
              v-model="student.form.checkedKeys"
            />
          </a-form-model-item>
        </template>
        <template v-if="student.step == 2">
          <a-form-model-item label="班级选择" prop="checkedKeys">
            <a-tree :replaceFields="{ children: 'childs', key: 'gradeClassID' }" :key="student.treeKey" :defaultExpandAll="true" :tree-data="student.treeData1" />
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  name: 'ConfigStudent',
  inject: ['update'],
  data() {
    return {
      student: {
        visible: false,
        loading: false,
        confirmLoading: false,
        setStatus: false,
        step: 1,
        form: {
          status: [2],
          checkedKeys: [],
        },
        treeKey: Date.now(),
        treeData: [],
        treeData2: [],
        rules: {
          status: [{ type: 'array', required: true, message: '请选择完成状态', trigger: 'change' }],
          checkedKeys: [{ type: 'array', required: true, message: '请选择班级', trigger: 'change' }],
        },
      },
    }
  },
  methods: {
    showModal(options = {}) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve
        this._reject = reject
        this.student.visible = true
        this._options = options
        this.setStudent(options || {})
      })
    },
    closeModal(reject) {
      reject ? this._reject() : this._resolve()
      this.student.visible = false
      this.student.form.status = [2]
    },
    handleCancel() {
      this.student = {
        ...this.student,
        step: 1,
        form: {
          status: [2],
          checkedKeys: [],
        },
        treeKey: Date.now(),
        treeData: [],
        setStatus: false,
      }
    },
    next(num) {
      if (num == 1) {
        this.student.step = num
        return
      }
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const Params = {
            userCourseSessionStatus: this.student.form.status,
            classIds: this.student.form.checkedKeys.filter((f) => typeof f === 'number'),
            groupReportCourseSessionId: this._options.groupReportCourseSessionId,
            groupReportId: this._options.groupReportId,
          }
          this.student.confirmLoading = true
          this.$http.ReportService.getConfigGroupStudent(Params)
            .then((res) => {
              const { status, data, message } = res
              this.student.treeData1 = [
                {
                  gradeClassID: '0',
                  title: `全部(${data.statistics.settingUserCount}/${data.statistics.userCount})`,
                  childs: setArr(data.statistics.gradeClasss),
                },
              ]
              this.student.step = num
              this.student.treeKey = Date.now()
            })
            .finally(() => {
              this.student.confirmLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })

      function setArr(arr) {
        return arr.map((m) => {
          m.title = m.gradeClassName + `(${m.settingUserCount}/${m.userCount})`
          m.childs = setArr(m.childs)
          return m
        })
      }
    },
    // 配置学生
    setStudent() {
      this.student.visible = true
      const Params = {
        groupReportCourseSessionId: this._options.groupReportCourseSessionId,
        // userCourseSessionStatus: this.student.form.status,
        classIds: [],
        groupReportId: this._options.groupReportId,
      }
      if (!Params.groupReportCourseSessionId) {
        Params.organizationId = this._options.organizationId
      }
      this.student.loading = true
      this.$http.ReportService.getConfigGroupStudent(Params)
        .then((res) => {
          const { status, data, message } = res
          if (!this.student.setStatus) {
            this.student.setStatus = true
            // this.student.form.status = data.participantConfig.completionStatus
          }
          if (!data.statistics.userCount) {
            return
          }
          this.student.form.checkedKeys = data.classIds
          this._checkedKeys = [...data.classIds]
          this.student.form.status = data.userCourseSessionStatus
          this.student.treeData = [
            {
              gradeClassID: '0',
              gradeClassName: '全部',
              courseChildUserCount: data.statistics.userCount,
              childs: data.statistics.gradeClasss.map((m) => {
                m.gradeClassID = m.gradeClassID + ''
                return m
              }),
            },
          ]
          this.student.treeKey = Date.now()
        })
        .finally(() => {
          this.student.loading = false
        })
    },
    // 配置学生
    studentSubmit() {
      const { groupReportId, groupReportCourseSessionId } = this._options
      const RequestBody = {
        groupReportId,
        groupReportCourseSessionId,
        userCourseSessionStatus: this.student.form.status,
        classIds: this.student.form.checkedKeys.filter((f) => typeof f !== 'string'),
      }
      if (this._options.organizationId) {
        RequestBody.organizationId = this._options.organizationId
      }
      this.student.confirmLoading = true
      this.$http.ReportService.configGroupStudent(RequestBody)
        .then((res) => {
          const { message } = res
          if (this.isChangeKeys()) {
            this.update && this.update()
          }
          this.student.visible = false
          this.student.step = 1
          this.student.setStatus = false
          this.student.form.status = [2]
          this.student.form.checkedKeys = []
          this.$message.success(message)
          this._options.success && this._options.success()
          this.closeModal()
        })
        .finally(() => {
          this.student.confirmLoading = false
        })
    },
    isChangeKeys() {
      const oldCheckKeys = this._checkedKeys
      const currentCheckKeys = this.student.form.checkedKeys.filter((f) => typeof f !== 'string')
      console.log(oldCheckKeys,currentCheckKeys);
      if (oldCheckKeys.length != currentCheckKeys.length) {
        return true
      }

      for (let i = 0; i < currentCheckKeys.length; i++) {
        if (!oldCheckKeys.some((key) => currentCheckKeys[i] == key)) {
          return true
        }
      }

      return false
    },
  },
}
</script>
